
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("fHioc"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("hkK1N"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("43HO2"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("dVU4V"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("dFhLL"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("hwnQI"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("3a0Ig"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("jnFs1"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("59c9s"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("fMrPK"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("bWzWf"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("jrhJx"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("fHioc", function(module, exports) {

let $02f2fc6f09283a67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $02f2fc6f09283a67$var$load("2YffH"),
    $02f2fc6f09283a67$var$load("8Kivm"),
    $02f2fc6f09283a67$var$load("2lBtX"),
    $02f2fc6f09283a67$var$load("kBo7y"),
    $02f2fc6f09283a67$var$load("iQ0Jm"),
    $02f2fc6f09283a67$var$load("coJiW"),
    $02f2fc6f09283a67$var$load("2vMNT"),
    $02f2fc6f09283a67$var$load("ahI4T"),
    $02f2fc6f09283a67$var$load("h4Nf7"),
    $02f2fc6f09283a67$var$load("7f9Fz"),
    $02f2fc6f09283a67$var$load("8YSo7"),
    $02f2fc6f09283a67$var$load("39eyQ"),
    $02f2fc6f09283a67$var$load("lYvov"),
    $02f2fc6f09283a67$var$load("lXGg9"),
    $02f2fc6f09283a67$var$load("hy3sK"),
    $02f2fc6f09283a67$var$load("g9CVe"),
    $02f2fc6f09283a67$var$load("aeEUI"),
    $02f2fc6f09283a67$var$load("hRUX7"),
    $02f2fc6f09283a67$var$load("g4oYs"),
    $02f2fc6f09283a67$var$load("6wr18"),
    $02f2fc6f09283a67$var$load("kjZZD"),
    $02f2fc6f09283a67$var$load("awqCy"),
    $02f2fc6f09283a67$var$load("kHOMt"),
    $02f2fc6f09283a67$var$load("hhss7"),
    $02f2fc6f09283a67$var$load("6kZfp"),
    $02f2fc6f09283a67$var$load("2UbDA"),
    $02f2fc6f09283a67$var$load("nbjnv"),
    $02f2fc6f09283a67$var$load("Wowvf"),
    $02f2fc6f09283a67$var$load("jlSv2"),
    $02f2fc6f09283a67$var$load("1UUrt"),
    $02f2fc6f09283a67$var$load("jSdjl"),
    $02f2fc6f09283a67$var$load("l2EUC"),
    $02f2fc6f09283a67$var$load("kWZnd"),
    $02f2fc6f09283a67$var$load("92LGf"),
    $02f2fc6f09283a67$var$load("let0D"),
    $02f2fc6f09283a67$var$load("joFPh"),
    $02f2fc6f09283a67$var$load("6M36W"),
    $02f2fc6f09283a67$var$load("ffEVr"),
    $02f2fc6f09283a67$var$load("kUbUu"),
    $02f2fc6f09283a67$var$load("2PePB"),
    $02f2fc6f09283a67$var$load("1W4KB"),
    $02f2fc6f09283a67$var$load("lnKog"),
    $02f2fc6f09283a67$var$load("9ftJe"),
    $02f2fc6f09283a67$var$load("h3ABO"),
    $02f2fc6f09283a67$var$load("kC80R"),
    $02f2fc6f09283a67$var$load("7EorR"),
    $02f2fc6f09283a67$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("hkK1N", function(module, exports) {

let $c9e8021facd227d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9e8021facd227d0$var$load("2YffH"),
    $c9e8021facd227d0$var$load("8Kivm"),
    $c9e8021facd227d0$var$load("2lBtX"),
    $c9e8021facd227d0$var$load("kBo7y"),
    $c9e8021facd227d0$var$load("iQ0Jm"),
    $c9e8021facd227d0$var$load("coJiW"),
    $c9e8021facd227d0$var$load("2vMNT"),
    $c9e8021facd227d0$var$load("ahI4T"),
    $c9e8021facd227d0$var$load("h4Nf7"),
    $c9e8021facd227d0$var$load("7f9Fz"),
    $c9e8021facd227d0$var$load("8YSo7"),
    $c9e8021facd227d0$var$load("39eyQ"),
    $c9e8021facd227d0$var$load("lYvov"),
    $c9e8021facd227d0$var$load("lXGg9"),
    $c9e8021facd227d0$var$load("hy3sK"),
    $c9e8021facd227d0$var$load("g9CVe"),
    $c9e8021facd227d0$var$load("aeEUI"),
    $c9e8021facd227d0$var$load("hRUX7"),
    $c9e8021facd227d0$var$load("g4oYs"),
    $c9e8021facd227d0$var$load("6wr18"),
    $c9e8021facd227d0$var$load("kjZZD"),
    $c9e8021facd227d0$var$load("awqCy"),
    $c9e8021facd227d0$var$load("kHOMt"),
    $c9e8021facd227d0$var$load("hhss7"),
    $c9e8021facd227d0$var$load("6kZfp"),
    $c9e8021facd227d0$var$load("2UbDA"),
    $c9e8021facd227d0$var$load("nbjnv"),
    $c9e8021facd227d0$var$load("Wowvf"),
    $c9e8021facd227d0$var$load("jlSv2"),
    $c9e8021facd227d0$var$load("1UUrt"),
    $c9e8021facd227d0$var$load("jSdjl"),
    $c9e8021facd227d0$var$load("l2EUC"),
    $c9e8021facd227d0$var$load("kWZnd"),
    $c9e8021facd227d0$var$load("92LGf"),
    $c9e8021facd227d0$var$load("let0D"),
    $c9e8021facd227d0$var$load("joFPh"),
    $c9e8021facd227d0$var$load("6M36W"),
    $c9e8021facd227d0$var$load("ffEVr"),
    $c9e8021facd227d0$var$load("kUbUu"),
    $c9e8021facd227d0$var$load("2PePB"),
    $c9e8021facd227d0$var$load("1W4KB"),
    $c9e8021facd227d0$var$load("lnKog"),
    $c9e8021facd227d0$var$load("9ftJe"),
    $c9e8021facd227d0$var$load("h3ABO"),
    $c9e8021facd227d0$var$load("kC80R"),
    $c9e8021facd227d0$var$load("7EorR"),
    $c9e8021facd227d0$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("43HO2", function(module, exports) {

let $2f496c39e6db4b00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f496c39e6db4b00$var$load("2YffH"),
    $2f496c39e6db4b00$var$load("8Kivm"),
    $2f496c39e6db4b00$var$load("2lBtX"),
    $2f496c39e6db4b00$var$load("kBo7y"),
    $2f496c39e6db4b00$var$load("iQ0Jm"),
    $2f496c39e6db4b00$var$load("coJiW"),
    $2f496c39e6db4b00$var$load("2vMNT"),
    $2f496c39e6db4b00$var$load("ahI4T"),
    $2f496c39e6db4b00$var$load("h4Nf7"),
    $2f496c39e6db4b00$var$load("7f9Fz"),
    $2f496c39e6db4b00$var$load("8YSo7"),
    $2f496c39e6db4b00$var$load("39eyQ"),
    $2f496c39e6db4b00$var$load("lYvov"),
    $2f496c39e6db4b00$var$load("lXGg9"),
    $2f496c39e6db4b00$var$load("hy3sK"),
    $2f496c39e6db4b00$var$load("g9CVe"),
    $2f496c39e6db4b00$var$load("aeEUI"),
    $2f496c39e6db4b00$var$load("hRUX7"),
    $2f496c39e6db4b00$var$load("g4oYs"),
    $2f496c39e6db4b00$var$load("6wr18"),
    $2f496c39e6db4b00$var$load("kjZZD"),
    $2f496c39e6db4b00$var$load("awqCy"),
    $2f496c39e6db4b00$var$load("kHOMt"),
    $2f496c39e6db4b00$var$load("hhss7"),
    $2f496c39e6db4b00$var$load("6kZfp"),
    $2f496c39e6db4b00$var$load("2UbDA"),
    $2f496c39e6db4b00$var$load("nbjnv"),
    $2f496c39e6db4b00$var$load("Wowvf"),
    $2f496c39e6db4b00$var$load("jlSv2"),
    $2f496c39e6db4b00$var$load("1UUrt"),
    $2f496c39e6db4b00$var$load("jSdjl"),
    $2f496c39e6db4b00$var$load("l2EUC"),
    $2f496c39e6db4b00$var$load("kWZnd"),
    $2f496c39e6db4b00$var$load("92LGf"),
    $2f496c39e6db4b00$var$load("let0D"),
    $2f496c39e6db4b00$var$load("joFPh"),
    $2f496c39e6db4b00$var$load("6M36W"),
    $2f496c39e6db4b00$var$load("ffEVr"),
    $2f496c39e6db4b00$var$load("kUbUu"),
    $2f496c39e6db4b00$var$load("2PePB"),
    $2f496c39e6db4b00$var$load("1W4KB"),
    $2f496c39e6db4b00$var$load("lnKog"),
    $2f496c39e6db4b00$var$load("9ftJe"),
    $2f496c39e6db4b00$var$load("h3ABO"),
    $2f496c39e6db4b00$var$load("kC80R"),
    $2f496c39e6db4b00$var$load("7EorR"),
    $2f496c39e6db4b00$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("dVU4V", function(module, exports) {

let $a24c1943ebc18f8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a24c1943ebc18f8f$var$load("lXGg9"),
    $a24c1943ebc18f8f$var$load("hy3sK"),
    $a24c1943ebc18f8f$var$load("2YffH"),
    $a24c1943ebc18f8f$var$load("2PePB"),
    $a24c1943ebc18f8f$var$load("2lBtX"),
    $a24c1943ebc18f8f$var$load("kBo7y"),
    $a24c1943ebc18f8f$var$load("2vMNT"),
    $a24c1943ebc18f8f$var$load("ahI4T"),
    $a24c1943ebc18f8f$var$load("h4Nf7"),
    $a24c1943ebc18f8f$var$load("7f9Fz"),
    $a24c1943ebc18f8f$var$load("8YSo7"),
    $a24c1943ebc18f8f$var$load("39eyQ"),
    $a24c1943ebc18f8f$var$load("lYvov"),
    $a24c1943ebc18f8f$var$load("g9CVe"),
    $a24c1943ebc18f8f$var$load("aeEUI"),
    $a24c1943ebc18f8f$var$load("hRUX7"),
    $a24c1943ebc18f8f$var$load("g4oYs"),
    $a24c1943ebc18f8f$var$load("6wr18"),
    $a24c1943ebc18f8f$var$load("kjZZD"),
    $a24c1943ebc18f8f$var$load("awqCy"),
    $a24c1943ebc18f8f$var$load("kHOMt"),
    $a24c1943ebc18f8f$var$load("hhss7"),
    $a24c1943ebc18f8f$var$load("6kZfp"),
    $a24c1943ebc18f8f$var$load("2UbDA"),
    $a24c1943ebc18f8f$var$load("nbjnv"),
    $a24c1943ebc18f8f$var$load("Wowvf"),
    $a24c1943ebc18f8f$var$load("jlSv2"),
    $a24c1943ebc18f8f$var$load("1UUrt"),
    $a24c1943ebc18f8f$var$load("jSdjl"),
    $a24c1943ebc18f8f$var$load("l2EUC"),
    $a24c1943ebc18f8f$var$load("kWZnd"),
    $a24c1943ebc18f8f$var$load("92LGf"),
    $a24c1943ebc18f8f$var$load("let0D"),
    $a24c1943ebc18f8f$var$load("joFPh"),
    $a24c1943ebc18f8f$var$load("6M36W"),
    $a24c1943ebc18f8f$var$load("1W4KB"),
    $a24c1943ebc18f8f$var$load("ffEVr"),
    $a24c1943ebc18f8f$var$load("kUbUu"),
    $a24c1943ebc18f8f$var$load("9ftJe"),
    $a24c1943ebc18f8f$var$load("h3ABO"),
    $a24c1943ebc18f8f$var$load("kC80R"),
    $a24c1943ebc18f8f$var$load("7EorR"),
    $a24c1943ebc18f8f$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("dFhLL", function(module, exports) {

let $9f2ce359603836c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f2ce359603836c1$var$load("lXGg9"),
    $9f2ce359603836c1$var$load("hy3sK"),
    $9f2ce359603836c1$var$load("2YffH"),
    $9f2ce359603836c1$var$load("2PePB"),
    $9f2ce359603836c1$var$load("2lBtX"),
    $9f2ce359603836c1$var$load("kBo7y"),
    $9f2ce359603836c1$var$load("2vMNT"),
    $9f2ce359603836c1$var$load("ahI4T"),
    $9f2ce359603836c1$var$load("h4Nf7"),
    $9f2ce359603836c1$var$load("7f9Fz"),
    $9f2ce359603836c1$var$load("8YSo7"),
    $9f2ce359603836c1$var$load("39eyQ"),
    $9f2ce359603836c1$var$load("lYvov"),
    $9f2ce359603836c1$var$load("g9CVe"),
    $9f2ce359603836c1$var$load("aeEUI"),
    $9f2ce359603836c1$var$load("hRUX7"),
    $9f2ce359603836c1$var$load("g4oYs"),
    $9f2ce359603836c1$var$load("6wr18"),
    $9f2ce359603836c1$var$load("kjZZD"),
    $9f2ce359603836c1$var$load("awqCy"),
    $9f2ce359603836c1$var$load("kHOMt"),
    $9f2ce359603836c1$var$load("hhss7"),
    $9f2ce359603836c1$var$load("6kZfp"),
    $9f2ce359603836c1$var$load("2UbDA"),
    $9f2ce359603836c1$var$load("nbjnv"),
    $9f2ce359603836c1$var$load("Wowvf"),
    $9f2ce359603836c1$var$load("jlSv2"),
    $9f2ce359603836c1$var$load("1UUrt"),
    $9f2ce359603836c1$var$load("jSdjl"),
    $9f2ce359603836c1$var$load("l2EUC"),
    $9f2ce359603836c1$var$load("kWZnd"),
    $9f2ce359603836c1$var$load("92LGf"),
    $9f2ce359603836c1$var$load("let0D"),
    $9f2ce359603836c1$var$load("joFPh"),
    $9f2ce359603836c1$var$load("6M36W"),
    $9f2ce359603836c1$var$load("1W4KB"),
    $9f2ce359603836c1$var$load("ffEVr"),
    $9f2ce359603836c1$var$load("kUbUu"),
    $9f2ce359603836c1$var$load("9ftJe"),
    $9f2ce359603836c1$var$load("h3ABO"),
    $9f2ce359603836c1$var$load("kC80R"),
    $9f2ce359603836c1$var$load("7EorR"),
    $9f2ce359603836c1$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("hwnQI", function(module, exports) {

let $cc17ecc4e5284b8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc17ecc4e5284b8f$var$load("lXGg9"),
    $cc17ecc4e5284b8f$var$load("hy3sK"),
    $cc17ecc4e5284b8f$var$load("2YffH"),
    $cc17ecc4e5284b8f$var$load("2PePB"),
    $cc17ecc4e5284b8f$var$load("2lBtX"),
    $cc17ecc4e5284b8f$var$load("kBo7y"),
    $cc17ecc4e5284b8f$var$load("2vMNT"),
    $cc17ecc4e5284b8f$var$load("ahI4T"),
    $cc17ecc4e5284b8f$var$load("h4Nf7"),
    $cc17ecc4e5284b8f$var$load("7f9Fz"),
    $cc17ecc4e5284b8f$var$load("8YSo7"),
    $cc17ecc4e5284b8f$var$load("39eyQ"),
    $cc17ecc4e5284b8f$var$load("lYvov"),
    $cc17ecc4e5284b8f$var$load("g9CVe"),
    $cc17ecc4e5284b8f$var$load("aeEUI"),
    $cc17ecc4e5284b8f$var$load("hRUX7"),
    $cc17ecc4e5284b8f$var$load("g4oYs"),
    $cc17ecc4e5284b8f$var$load("6wr18"),
    $cc17ecc4e5284b8f$var$load("kjZZD"),
    $cc17ecc4e5284b8f$var$load("awqCy"),
    $cc17ecc4e5284b8f$var$load("kHOMt"),
    $cc17ecc4e5284b8f$var$load("hhss7"),
    $cc17ecc4e5284b8f$var$load("6kZfp"),
    $cc17ecc4e5284b8f$var$load("2UbDA"),
    $cc17ecc4e5284b8f$var$load("nbjnv"),
    $cc17ecc4e5284b8f$var$load("Wowvf"),
    $cc17ecc4e5284b8f$var$load("jlSv2"),
    $cc17ecc4e5284b8f$var$load("1UUrt"),
    $cc17ecc4e5284b8f$var$load("jSdjl"),
    $cc17ecc4e5284b8f$var$load("l2EUC"),
    $cc17ecc4e5284b8f$var$load("kWZnd"),
    $cc17ecc4e5284b8f$var$load("92LGf"),
    $cc17ecc4e5284b8f$var$load("let0D"),
    $cc17ecc4e5284b8f$var$load("joFPh"),
    $cc17ecc4e5284b8f$var$load("6M36W"),
    $cc17ecc4e5284b8f$var$load("1W4KB"),
    $cc17ecc4e5284b8f$var$load("ffEVr"),
    $cc17ecc4e5284b8f$var$load("kUbUu"),
    $cc17ecc4e5284b8f$var$load("9ftJe"),
    $cc17ecc4e5284b8f$var$load("h3ABO"),
    $cc17ecc4e5284b8f$var$load("kC80R"),
    $cc17ecc4e5284b8f$var$load("7EorR"),
    $cc17ecc4e5284b8f$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("3a0Ig", function(module, exports) {

let $24d2dbde7b73cb97$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $24d2dbde7b73cb97$var$load("lXGg9"),
    $24d2dbde7b73cb97$var$load("hy3sK"),
    $24d2dbde7b73cb97$var$load("2YffH"),
    $24d2dbde7b73cb97$var$load("2lBtX"),
    $24d2dbde7b73cb97$var$load("kBo7y"),
    $24d2dbde7b73cb97$var$load("2vMNT"),
    $24d2dbde7b73cb97$var$load("ahI4T"),
    $24d2dbde7b73cb97$var$load("h4Nf7"),
    $24d2dbde7b73cb97$var$load("7f9Fz"),
    $24d2dbde7b73cb97$var$load("8YSo7"),
    $24d2dbde7b73cb97$var$load("39eyQ"),
    $24d2dbde7b73cb97$var$load("lYvov"),
    $24d2dbde7b73cb97$var$load("g9CVe"),
    $24d2dbde7b73cb97$var$load("aeEUI"),
    $24d2dbde7b73cb97$var$load("hRUX7"),
    $24d2dbde7b73cb97$var$load("g4oYs"),
    $24d2dbde7b73cb97$var$load("6wr18"),
    $24d2dbde7b73cb97$var$load("kjZZD"),
    $24d2dbde7b73cb97$var$load("awqCy"),
    $24d2dbde7b73cb97$var$load("kHOMt"),
    $24d2dbde7b73cb97$var$load("hhss7"),
    $24d2dbde7b73cb97$var$load("6kZfp"),
    $24d2dbde7b73cb97$var$load("2UbDA"),
    $24d2dbde7b73cb97$var$load("nbjnv"),
    $24d2dbde7b73cb97$var$load("Wowvf"),
    $24d2dbde7b73cb97$var$load("jlSv2"),
    $24d2dbde7b73cb97$var$load("1UUrt"),
    $24d2dbde7b73cb97$var$load("jSdjl"),
    $24d2dbde7b73cb97$var$load("l2EUC"),
    $24d2dbde7b73cb97$var$load("kWZnd"),
    $24d2dbde7b73cb97$var$load("92LGf"),
    $24d2dbde7b73cb97$var$load("let0D"),
    $24d2dbde7b73cb97$var$load("joFPh"),
    $24d2dbde7b73cb97$var$load("6M36W"),
    $24d2dbde7b73cb97$var$load("ffEVr"),
    $24d2dbde7b73cb97$var$load("kUbUu"),
    $24d2dbde7b73cb97$var$load("2PePB"),
    $24d2dbde7b73cb97$var$load("1W4KB"),
    $24d2dbde7b73cb97$var$load("lnKog"),
    $24d2dbde7b73cb97$var$load("9ftJe"),
    $24d2dbde7b73cb97$var$load("h3ABO"),
    $24d2dbde7b73cb97$var$load("kC80R"),
    $24d2dbde7b73cb97$var$load("7EorR"),
    $24d2dbde7b73cb97$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("jnFs1", function(module, exports) {

let $e1c051955db627f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1c051955db627f7$var$load("2YffH"),
    $e1c051955db627f7$var$load("2lBtX"),
    $e1c051955db627f7$var$load("kBo7y"),
    $e1c051955db627f7$var$load("coJiW"),
    $e1c051955db627f7$var$load("2vMNT"),
    $e1c051955db627f7$var$load("ahI4T"),
    $e1c051955db627f7$var$load("h4Nf7"),
    $e1c051955db627f7$var$load("7f9Fz"),
    $e1c051955db627f7$var$load("8YSo7"),
    $e1c051955db627f7$var$load("39eyQ"),
    $e1c051955db627f7$var$load("lYvov"),
    $e1c051955db627f7$var$load("lXGg9"),
    $e1c051955db627f7$var$load("hy3sK"),
    $e1c051955db627f7$var$load("g9CVe"),
    $e1c051955db627f7$var$load("aeEUI"),
    $e1c051955db627f7$var$load("hRUX7"),
    $e1c051955db627f7$var$load("g4oYs"),
    $e1c051955db627f7$var$load("6wr18"),
    $e1c051955db627f7$var$load("kjZZD"),
    $e1c051955db627f7$var$load("dTsOE"),
    $e1c051955db627f7$var$load("awqCy"),
    $e1c051955db627f7$var$load("kHOMt"),
    $e1c051955db627f7$var$load("hhss7"),
    $e1c051955db627f7$var$load("6kZfp"),
    $e1c051955db627f7$var$load("2UbDA"),
    $e1c051955db627f7$var$load("nbjnv"),
    $e1c051955db627f7$var$load("Wowvf"),
    $e1c051955db627f7$var$load("jlSv2"),
    $e1c051955db627f7$var$load("1UUrt"),
    $e1c051955db627f7$var$load("jSdjl"),
    $e1c051955db627f7$var$load("l2EUC"),
    $e1c051955db627f7$var$load("kWZnd"),
    $e1c051955db627f7$var$load("92LGf"),
    $e1c051955db627f7$var$load("let0D"),
    $e1c051955db627f7$var$load("joFPh"),
    $e1c051955db627f7$var$load("6M36W"),
    $e1c051955db627f7$var$load("ffEVr"),
    $e1c051955db627f7$var$load("kUbUu"),
    $e1c051955db627f7$var$load("2PePB"),
    $e1c051955db627f7$var$load("1W4KB"),
    $e1c051955db627f7$var$load("lnKog"),
    $e1c051955db627f7$var$load("9ftJe"),
    $e1c051955db627f7$var$load("h3ABO"),
    $e1c051955db627f7$var$load("kC80R"),
    $e1c051955db627f7$var$load("7EorR"),
    $e1c051955db627f7$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("59c9s", function(module, exports) {

let $3bf7380f00173015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3bf7380f00173015$var$load("2YffH"),
    $3bf7380f00173015$var$load("2lBtX"),
    $3bf7380f00173015$var$load("kBo7y"),
    $3bf7380f00173015$var$load("coJiW"),
    $3bf7380f00173015$var$load("2vMNT"),
    $3bf7380f00173015$var$load("ahI4T"),
    $3bf7380f00173015$var$load("h4Nf7"),
    $3bf7380f00173015$var$load("7f9Fz"),
    $3bf7380f00173015$var$load("8YSo7"),
    $3bf7380f00173015$var$load("39eyQ"),
    $3bf7380f00173015$var$load("lYvov"),
    $3bf7380f00173015$var$load("lXGg9"),
    $3bf7380f00173015$var$load("hy3sK"),
    $3bf7380f00173015$var$load("g9CVe"),
    $3bf7380f00173015$var$load("aeEUI"),
    $3bf7380f00173015$var$load("hRUX7"),
    $3bf7380f00173015$var$load("g4oYs"),
    $3bf7380f00173015$var$load("6wr18"),
    $3bf7380f00173015$var$load("kjZZD"),
    $3bf7380f00173015$var$load("dTsOE"),
    $3bf7380f00173015$var$load("awqCy"),
    $3bf7380f00173015$var$load("kHOMt"),
    $3bf7380f00173015$var$load("hhss7"),
    $3bf7380f00173015$var$load("6kZfp"),
    $3bf7380f00173015$var$load("2UbDA"),
    $3bf7380f00173015$var$load("nbjnv"),
    $3bf7380f00173015$var$load("Wowvf"),
    $3bf7380f00173015$var$load("jlSv2"),
    $3bf7380f00173015$var$load("1UUrt"),
    $3bf7380f00173015$var$load("jSdjl"),
    $3bf7380f00173015$var$load("l2EUC"),
    $3bf7380f00173015$var$load("kWZnd"),
    $3bf7380f00173015$var$load("92LGf"),
    $3bf7380f00173015$var$load("let0D"),
    $3bf7380f00173015$var$load("joFPh"),
    $3bf7380f00173015$var$load("6M36W"),
    $3bf7380f00173015$var$load("ffEVr"),
    $3bf7380f00173015$var$load("kUbUu"),
    $3bf7380f00173015$var$load("2PePB"),
    $3bf7380f00173015$var$load("1W4KB"),
    $3bf7380f00173015$var$load("lnKog"),
    $3bf7380f00173015$var$load("9ftJe"),
    $3bf7380f00173015$var$load("h3ABO"),
    $3bf7380f00173015$var$load("kC80R"),
    $3bf7380f00173015$var$load("7EorR"),
    $3bf7380f00173015$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("fMrPK", function(module, exports) {

let $b7d0eddf23d14405$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b7d0eddf23d14405$var$load("lXGg9"),
    $b7d0eddf23d14405$var$load("hy3sK"),
    $b7d0eddf23d14405$var$load("2YffH"),
    $b7d0eddf23d14405$var$load("2PePB"),
    $b7d0eddf23d14405$var$load("2lBtX"),
    $b7d0eddf23d14405$var$load("kBo7y"),
    $b7d0eddf23d14405$var$load("2vMNT"),
    $b7d0eddf23d14405$var$load("ahI4T"),
    $b7d0eddf23d14405$var$load("h4Nf7"),
    $b7d0eddf23d14405$var$load("7f9Fz"),
    $b7d0eddf23d14405$var$load("8YSo7"),
    $b7d0eddf23d14405$var$load("39eyQ"),
    $b7d0eddf23d14405$var$load("lYvov"),
    $b7d0eddf23d14405$var$load("g9CVe"),
    $b7d0eddf23d14405$var$load("aeEUI"),
    $b7d0eddf23d14405$var$load("hRUX7"),
    $b7d0eddf23d14405$var$load("g4oYs"),
    $b7d0eddf23d14405$var$load("6wr18"),
    $b7d0eddf23d14405$var$load("kjZZD"),
    $b7d0eddf23d14405$var$load("awqCy"),
    $b7d0eddf23d14405$var$load("kHOMt"),
    $b7d0eddf23d14405$var$load("hhss7"),
    $b7d0eddf23d14405$var$load("6kZfp"),
    $b7d0eddf23d14405$var$load("2UbDA"),
    $b7d0eddf23d14405$var$load("nbjnv"),
    $b7d0eddf23d14405$var$load("Wowvf"),
    $b7d0eddf23d14405$var$load("jlSv2"),
    $b7d0eddf23d14405$var$load("1UUrt"),
    $b7d0eddf23d14405$var$load("jSdjl"),
    $b7d0eddf23d14405$var$load("l2EUC"),
    $b7d0eddf23d14405$var$load("kWZnd"),
    $b7d0eddf23d14405$var$load("92LGf"),
    $b7d0eddf23d14405$var$load("let0D"),
    $b7d0eddf23d14405$var$load("joFPh"),
    $b7d0eddf23d14405$var$load("6M36W"),
    $b7d0eddf23d14405$var$load("1W4KB"),
    $b7d0eddf23d14405$var$load("ffEVr"),
    $b7d0eddf23d14405$var$load("kUbUu"),
    $b7d0eddf23d14405$var$load("9ftJe"),
    $b7d0eddf23d14405$var$load("h3ABO"),
    $b7d0eddf23d14405$var$load("kC80R"),
    $b7d0eddf23d14405$var$load("7EorR"),
    $b7d0eddf23d14405$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("bWzWf", function(module, exports) {

let $8b20fd220ea3526e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b20fd220ea3526e$var$load("lXGg9"),
    $8b20fd220ea3526e$var$load("hy3sK"),
    $8b20fd220ea3526e$var$load("2YffH"),
    $8b20fd220ea3526e$var$load("2lBtX"),
    $8b20fd220ea3526e$var$load("kBo7y"),
    $8b20fd220ea3526e$var$load("2vMNT"),
    $8b20fd220ea3526e$var$load("ahI4T"),
    $8b20fd220ea3526e$var$load("h4Nf7"),
    $8b20fd220ea3526e$var$load("7f9Fz"),
    $8b20fd220ea3526e$var$load("8YSo7"),
    $8b20fd220ea3526e$var$load("39eyQ"),
    $8b20fd220ea3526e$var$load("lYvov"),
    $8b20fd220ea3526e$var$load("g9CVe"),
    $8b20fd220ea3526e$var$load("aeEUI"),
    $8b20fd220ea3526e$var$load("hRUX7"),
    $8b20fd220ea3526e$var$load("g4oYs"),
    $8b20fd220ea3526e$var$load("6wr18"),
    $8b20fd220ea3526e$var$load("kjZZD"),
    $8b20fd220ea3526e$var$load("awqCy"),
    $8b20fd220ea3526e$var$load("kHOMt"),
    $8b20fd220ea3526e$var$load("hhss7"),
    $8b20fd220ea3526e$var$load("6kZfp"),
    $8b20fd220ea3526e$var$load("2UbDA"),
    $8b20fd220ea3526e$var$load("nbjnv"),
    $8b20fd220ea3526e$var$load("Wowvf"),
    $8b20fd220ea3526e$var$load("jlSv2"),
    $8b20fd220ea3526e$var$load("1UUrt"),
    $8b20fd220ea3526e$var$load("jSdjl"),
    $8b20fd220ea3526e$var$load("l2EUC"),
    $8b20fd220ea3526e$var$load("kWZnd"),
    $8b20fd220ea3526e$var$load("92LGf"),
    $8b20fd220ea3526e$var$load("let0D"),
    $8b20fd220ea3526e$var$load("joFPh"),
    $8b20fd220ea3526e$var$load("6M36W"),
    $8b20fd220ea3526e$var$load("ffEVr"),
    $8b20fd220ea3526e$var$load("kUbUu"),
    $8b20fd220ea3526e$var$load("2PePB"),
    $8b20fd220ea3526e$var$load("1W4KB"),
    $8b20fd220ea3526e$var$load("lnKog"),
    $8b20fd220ea3526e$var$load("9ftJe"),
    $8b20fd220ea3526e$var$load("h3ABO"),
    $8b20fd220ea3526e$var$load("kC80R"),
    $8b20fd220ea3526e$var$load("7EorR"),
    $8b20fd220ea3526e$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("jrhJx", function(module, exports) {

let $e26e4b6e0ed2b539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e26e4b6e0ed2b539$var$load("lXGg9"),
    $e26e4b6e0ed2b539$var$load("hy3sK"),
    $e26e4b6e0ed2b539$var$load("2YffH"),
    $e26e4b6e0ed2b539$var$load("2lBtX"),
    $e26e4b6e0ed2b539$var$load("kBo7y"),
    $e26e4b6e0ed2b539$var$load("2vMNT"),
    $e26e4b6e0ed2b539$var$load("ahI4T"),
    $e26e4b6e0ed2b539$var$load("h4Nf7"),
    $e26e4b6e0ed2b539$var$load("7f9Fz"),
    $e26e4b6e0ed2b539$var$load("8YSo7"),
    $e26e4b6e0ed2b539$var$load("39eyQ"),
    $e26e4b6e0ed2b539$var$load("lYvov"),
    $e26e4b6e0ed2b539$var$load("g9CVe"),
    $e26e4b6e0ed2b539$var$load("aeEUI"),
    $e26e4b6e0ed2b539$var$load("hRUX7"),
    $e26e4b6e0ed2b539$var$load("g4oYs"),
    $e26e4b6e0ed2b539$var$load("6wr18"),
    $e26e4b6e0ed2b539$var$load("kjZZD"),
    $e26e4b6e0ed2b539$var$load("awqCy"),
    $e26e4b6e0ed2b539$var$load("kHOMt"),
    $e26e4b6e0ed2b539$var$load("hhss7"),
    $e26e4b6e0ed2b539$var$load("6kZfp"),
    $e26e4b6e0ed2b539$var$load("2UbDA"),
    $e26e4b6e0ed2b539$var$load("nbjnv"),
    $e26e4b6e0ed2b539$var$load("Wowvf"),
    $e26e4b6e0ed2b539$var$load("jlSv2"),
    $e26e4b6e0ed2b539$var$load("1UUrt"),
    $e26e4b6e0ed2b539$var$load("jSdjl"),
    $e26e4b6e0ed2b539$var$load("l2EUC"),
    $e26e4b6e0ed2b539$var$load("kWZnd"),
    $e26e4b6e0ed2b539$var$load("92LGf"),
    $e26e4b6e0ed2b539$var$load("let0D"),
    $e26e4b6e0ed2b539$var$load("joFPh"),
    $e26e4b6e0ed2b539$var$load("6M36W"),
    $e26e4b6e0ed2b539$var$load("ffEVr"),
    $e26e4b6e0ed2b539$var$load("kUbUu"),
    $e26e4b6e0ed2b539$var$load("2PePB"),
    $e26e4b6e0ed2b539$var$load("1W4KB"),
    $e26e4b6e0ed2b539$var$load("lnKog"),
    $e26e4b6e0ed2b539$var$load("9ftJe"),
    $e26e4b6e0ed2b539$var$load("h3ABO"),
    $e26e4b6e0ed2b539$var$load("kC80R"),
    $e26e4b6e0ed2b539$var$load("7EorR"),
    $e26e4b6e0ed2b539$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.94ac8963.js.map
